import type { CSSProperties } from 'react'
import { Avatar } from './Avatar'
import type { AccentVar } from './AccentContext'

export function Requester({
  initials,
  name,
  email,
  color,
  className,
  style
}: {
  initials: string
  name: string
  email?: string
  color?: AccentVar | string
  className?: string
  style?: CSSProperties
}) {
  return (
    <div className={className ? `st-requester ${className}` : 'st-requester'} style={style}>
      <Avatar initials={initials} color={color} />
      <div className="who">
        <b>{name}</b>
        <span>{email}</span>
      </div>
    </div>
  )
}
